import styled from "styled-components";
import { COLORS } from "../../../styles/constants.style";

interface MuiViewMorePopOverWrapperProps {
  maxLines: number;
  anchorTextWidth: number;
}

export const MuiViewMorePopOverWrapper = styled.div<MuiViewMorePopOverWrapperProps>`
  width: 100%;
  display: block !important;

  .tooltip-content {
    overflow-x: hidden;
  }

  .ellipsis-tooltip-container {
    display: flex !important;
    flex-direction: ${({ maxLines }) => (maxLines === 1 ? "row" : "column")};
    align-items: ${({ maxLines }) =>
      maxLines === 1 ? "flex-start" : "flex-end"};
    width: 100%;
  }

  .ellipsis,
  div.ellipsis {
    overflow: hidden;
    ${({ maxLines, anchorTextWidth }) =>
      maxLines === 1
        ? `
          /* Single-line truncation (width-based) */
          display: inline-block !important;
          white-space: nowrap;
          text-overflow: ellipsis;
          flex: 1;
          min-width: 0;
        `
        : `
          /* Multi-line truncation (height-based) */
          display: -webkit-box !important;
          -webkit-line-clamp: ${maxLines};
          -webkit-box-orient: vertical;
          overflow-wrap: break-word;
          white-space: normal;
          width: 100%;
          padding-right: ${anchorTextWidth > 100 ? 150 : 100}px;
        `}
  }

  .anchor-text,
  div.anchor-text {
    flex-shrink: 0;
    cursor: pointer;
    text-decoration: underline;
    color: ${COLORS.primary_light_blue};
    white-space: nowrap;
    margin-left: 4px;

    ${({ maxLines }) =>
      maxLines > 1 &&
      `
      /* Multi-line: position at end of last line */
      margin-left: 0;
      margin-top: -1.2em;
      align-self: flex-end;
      z-index: 1;
    `}
  }
`;
